import {
  AppBar,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  styled,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import sanMiguelLogo from '../assets/login-logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
// import NotificationsIcon from '@mui/icons-material/Notifications';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import { getNotificacionesNumber, getUnreadNotNumber } from '../features/notificaciones/notificacionesSlice';
import { authed, getLogoutUrl, logout } from '../features/login/loginSlice';
import { store } from '../store';
import { getImponiblesList } from '../features/imponibles/imponiblesSlice';
import { getUrlLink } from '../features/ddjj/decJuradaSlice';

const ButtonContainer = styled(Box)(({ theme }) => ({
  width: '2.4rem',
  height: '2.4rem',
  color: theme.palette.primary.main,
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  borderRadius: '5px',
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '.4rem',
}));

// const UnreadNotification = styled(Typography)(() => ({
//   fontSize: '.9rem',
//   fontWeight: 'bold',
//   color: 'white',
// }));

export default function Navbar() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  // const notifications = useSelector(getNotificacionesNumber);
  const isLogged = useSelector(authed);
  const imponibles = useSelector(getImponiblesList);
  const url = useSelector(getUrlLink);
  const logoutUrl = useSelector(getLogoutUrl);

  const haveComercio = imponibles.some(imponible => imponible.tipo === 'COM');

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleHomeClick = () => {
    setAnchorEl(null);
    navigate('/');
  };

  const handleLogInClick = () => {
    setAnchorEl(null);
    navigate('/login');
  };

  const handlePayBillClick = () => {
    setAnchorEl(null);
    navigate('/paga-tu-tasa');
  };

  const handleQuestionsClick = () => {
    setAnchorEl(null);
    navigate('/preguntas-frecuentes');
  };

  const handleVoucherClick = () => {
    setAnchorEl(null);
    navigate('/boleta');
  };

  const handleAutomaticDebClick = () => {
    setAnchorEl(null);
    navigate('/debito-automatico');
  };

  const handlePayFineClick = () => {
    setAnchorEl(null);
    window.location.href = 'https://juzgadodefaltas.msm.gov.ar/ords/smi/f?p=204';
  };

  // const handleNotificationsClick = () => {
  //   setAnchorEl(null);
  //   navigate('/notificaciones');
  // };

  const handleProfileClick = () => {
    setAnchorEl(null);
    navigate('/perfil');
  };

  const handleMyPaymentsClick = () => {
    setAnchorEl(null);
    navigate('/mis-pagos');
  };

  const handleLogOutClick = () => {
    setAnchorEl(null);
    store.dispatch(logout());
    if (logoutUrl) {
      window.location.replace(logoutUrl);
    } else {
      navigate('/login');
    }
  };

  const scrollDown = () => {
    const element = document.getElementById('Imponibles');

    if (location.pathname === '/') {
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    } else {
      navigate('/');
      setTimeout(() => {
        const element2 = document.getElementById('Imponibles');
        element2?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 1500);
    }
  };

  // useEffect(() => {
  //   const id = setInterval(() => store.dispatch(getUnreadNotNumber()), 1000 * 30);
  //   store.dispatch(getUnreadNotNumber());

  //   return () => clearInterval(id);
  // }, []);

  const buttonText = import.meta.env.VITE_EPAGOS === 'true' ? 'Inicio' : 'Iniciar Sesión';

  return (
    <AppBar component="nav" color="default">
      <Container>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Box onClick={isLogged ? handleHomeClick : handleLogInClick}>
              <img
                src={sanMiguelLogo}
                style={{
                  cursor: 'pointer',
                  maxWidth: '45%',
                  height: 'auto',
                }}
              />
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            {isLogged ? (
              <>
                {/* <Box
                  style={{ textDecoration: 'none' }}
                  onClick={handleNotificationsClick}
                >
                  <ButtonContainer
                    sx={{
                      backgroundColor:
                        notifications >= 1
                          ? theme.palette.primary.main
                          : 'transparent',
                    }}
                  >
                    <Tooltip title="Domicilio Fiscal Electrónico">
                      <IconButton disableRipple sx={{ color: '#36B7E8' }}>
                        {notifications >= 1 ? (
                          <UnreadNotification>
                            {notifications}
                          </UnreadNotification>
                        ) : (
                          <NotificationsIcon />
                        )}
                      </IconButton>
                    </Tooltip>
                  </ButtonContainer>
                </Box> */}
                <Box onClick={handleProfileClick}>
                  <ButtonContainer>
                    <Tooltip title="Perfil">
                      <IconButton disableRipple sx={{ color: '#36B7E8' }}>
                        <PersonIcon />
                      </IconButton>
                    </Tooltip>
                  </ButtonContainer>
                </Box>
              </>
            ) : null}
            <Box>
              <ButtonContainer onClick={e => handleClick(e)}>
                <MenuIcon />
              </ButtonContainer>
            </Box>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {
                isLogged
                  ? <div>
                    <MenuItem
                      onClick={handleHomeClick}
                      selected={pathname === '/'}
                    >Inicio</MenuItem>
                    <MenuItem onClick={() => scrollDown()}>
                      Mis Imponibles
                    </MenuItem>
                    <MenuItem
                      onClick={handleMyPaymentsClick}
                      selected={pathname === '/mis-pagos'}
                    >Mis Pagos
                    </MenuItem>
                    <MenuItem onClick={handlePayFineClick}>
                      Pagá tu multa
                    </MenuItem>
                    <MenuItem onClick={handleAutomaticDebClick}>
                      Débito Automático
                    </MenuItem>
                    {
                      haveComercio
                        ? <MenuItem onClick={() => window.open(url)}>
                          Declaraciones Juradas
                        </MenuItem>
                        : null
                    }
                    <MenuItem
                      onClick={handleQuestionsClick}
                      selected={pathname === '/preguntas-frecuentes'}
                    >
                      Preguntas Frecuentes
                    </MenuItem>

                    {/* <MenuItem
                      onClick={handleMethodsClick}
                      selected={pathname === '/medios-pagos'}
                    >Medios de pago adheridos
                    </MenuItem> */}

                    <MenuItem onClick={handleLogOutClick}>Cerrar Sesión</MenuItem>
                  </div>
                  : <div>
                    <MenuItem onClick={handleLogInClick}>
                      {buttonText}
                    </MenuItem>
                    <MenuItem onClick={handlePayBillClick}>
                      Pagá tu tasa
                    </MenuItem>
                    <MenuItem sx={{ display: import.meta.env.VITE_EPAGOS === 'true' ? 'none' : 'flex' }} onClick={handlePayFineClick}>
                      Pagá tu multa
                    </MenuItem>
                    <MenuItem onClick={handleAutomaticDebClick}>
                      Débito Automático
                    </MenuItem>
                    <MenuItem onClick={handleVoucherClick}>
                      Boleta por mail
                    </MenuItem>
                    <MenuItem onClick={handleQuestionsClick}>
                      Preguntas Frecuentes
                    </MenuItem>
                  </div>
              }
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
